<form id="nmj-investments" [ngrxFormState]="form" *ngIf="form$|async; let form" class="w-100" autocomplete="off"
    role="presentation" class="col-12 p-0">

    <!-- not manual split mode -->
    <ng-container *ngIf="!(isManualSplit$|async)">
        <div class="content">
            <h3 class="content-title">Choose one option below, or hit 'Split my investment option' if you want to
                diversify.
            </h3>

            <!-- show list of investment option cards -->
            <!-- each investment card should have a button which when clicked will automatically add all 100% into option and trigger api request -->
            <div class="investment-list">
                <ng-container *ngFor="let investment of (formInvestmentOptions$|async)?.controls; index as i">
                    <app-investment-card [option]="investment.value"
                        (onSelected)="selectInvestmentOption($event)"></app-investment-card>
                </ng-container>
            </div>

        </div>

        <div class="footer mt-2 mb-2">
            &dagger; Fees and costs are correct as at 24 May 2025. Other fees and costs may apply, including activity fees,
            buy-sell spreads and insurance fees (where applicable). Please read the <a href="https://vervesuper.com.au/docs/product-disclosure-statement" target="_blank">Product Disclosure Statement</a> for more
            information. We reserve the right to change our fees and/or costs in future.
        </div>
    </ng-container>

    <ng-container *ngIf="isManualSplit$|async">
        <div class="content">
            <div class="manual-split-container">
                <!-- top row -->
                <div class="manual-split-container-row">
                    <div class="left">
                        <div class="left-header top-row">Fill in your preferred split.</div>
                        <div class="left-text">Only enter the options you want your super to go into.</div>
                    </div>
                    <div class="right">
                        <div class="small-text">
                            Minimum of 5% for any option selected
                        </div>
                    </div>
                </div>

                <!-- list out investment options similar to investment switch functionality -->
                <ng-container *ngFor="let investment of (formInvestmentOptions$|async)?.controls; index as i;
                    trackBy: trackByFn">
                    <div class="manual-split-container-row" *ngIf="investment.value.investmentOptionId !== -1">

                        <div class="left">
                            <div class="left-header">{{investment.value.optionName}}</div>
                            <div class="left-text">
                                <app-investment-tooltip [tooltipText]="investmentSplitTooltip"></app-investment-tooltip>
                                <div class="split-info">{{getSplitInfo(investment.value)}}</div>
                            </div>
                        </div>
                        <div class="right">
                            <app-entry-number icon="percent" title="" [control]="investment.controls.percentage"
                                [decimalplaces]="0" [showincremental]="false"></app-entry-number>
                        </div>
                    </div>
                </ng-container>

                <!-- bottom row -->
                <div class="manual-split-container-row bottom-row">
                    <div class="left">
                        <div class="left-header top-row">Total</div>
                        <div class="left-text">Must equal 100%</div>
                    </div>
                    <div class="right total">
                        <div class="total-percent-row">
                            <div class="total-percent">
                                {{totalPercent}}%
                            </div>
                            <div *ngIf="totalPercent !== 100" class="add-more-text">{{getAddMoreText()}}</div>
                        </div>
                    </div>
                </div>


            </div>


            <div class="card-bottom d-flex d-flex flex-row justify-content-end mt-3 mb-4 ">
                <app-button class="back-btn investments-list-btn" title="investments list" color="light" icon="west"
                    (onClick)="cancelInvestmentSplit()">
                </app-button>
            </div>
        </div>
    </ng-container> 

    <div class="card-bottom d-flex d-flex flex-row justify-content-between mt-3 mb-4 ">
        <app-button class="back-btn" title="Back" color="light" icon="west" [isDisabled]="(isLoading$ | async)" (onClick)="onMoveBackClick()">
        </app-button>
        <app-button class="custom" title="Next" [isDisabled]="(isLoading$ | async) || form.isInvalid" icon="east"
            loading (onClick)="onMoveNextClick(form)">
        </app-button>
    </div>

    <div class="footer footer-mobile  mt-5">
        <ng-template class="" [ngTemplateOutlet]="FooterInvestments"></ng-template>
    </div>
</form>

<ng-template #FooterInvestments>
    <h5>
        Need help?
        <a href="https://vervesuper.com.au/contact-us/" target="_blank">Contact us.</a>
    </h5>
    <p>
        All information is of a general nature only. It is important to do your own
        research and consider things like fees, investment performance, insurance,
        risk, and alignment with your values when considering if Verve Super is
        right for you. Consider seeking financial advice. When considering
        performance, past performance is not indicative of future performance.
        <a href="https://vervesuper.com.au/fund-information/" target="_blank">Fund information.</a>
    </p>
</ng-template>